export default "__VITE_ASSET__COZCxuvL__"